import { render, staticRenderFns } from "./EditCampusComponent.vue?vue&type=template&id=078950ce&"
import script from "./EditCampusComponent.vue?vue&type=script&lang=js&"
export * from "./EditCampusComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports